import { DEVICES } from 'utils/products/devices';

/**
 * Renames the file extension of the given file name to mp4
 * @param fileName - The name of the file to rename
 * @returns The new file name with the extension changed to mp4
 * @throws Error if the file name is invalid
 */
export const renameFileExtensionToMp4 = (fileName: string): string => {
  // Rename file to mp4 extension
  const lastDotIndex = fileName.lastIndexOf('.');
  // Invalid file names
  if (
    // no file extension
    lastDotIndex === -1 ||
    // only dot in the file name
    fileName === '.' ||
    // dot at the beginning of the file name
    lastDotIndex === 0 ||
    // dot at the end of the file name
    lastDotIndex === fileName.length - 1 ||
    // file extension longer than 3 characters
    fileName.substring(lastDotIndex + 1).length > 3 ||
    // file extension is not supported by the application
    !DEVICES.some(({ acceptedExtensions }) => {
      const fileExtension = fileName.substring(lastDotIndex + 1).toLowerCase();
      return acceptedExtensions?.includes(`.${fileExtension}`);
    })
  ) {
    throw new Error('Invalid file name');
  }

  const newFileName = fileName.substring(0, lastDotIndex) + '.mp4';

  return newFileName;
};

/**
 * Renames the file preserving the extension
 * @param file - File to rename
 * @param newName - New name for the file without extension
 * @returns A new File object with the updated name
 */
export const renameFile = (file: File, newName: string): File => {
  const extension = file.name.split('.').pop();
  return new File(
    [file],
    extension ? `${newName}.${extension}` : `${newName}`,
    { type: file.type },
  );
};
